<template>
  <div class="index">
    <banner :swiperData="swiperData" />
    <div class="our-product">
      <p class="title">我们的产品</p>
      <div class="width1746">
        <swiper
          class="product-swiper"
          :options="productSwiperOption"
          ref="productSwiper"
        >
          <swiper-slide v-for="(item, index) in productSwiperData" :key="index">
            <div class="product-list">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
              <img :src="item.imgUrl" alt="" class="w-100" />
              <p>{{ item.price }}</p>
            </div>
            <div class="product-list-show">
              <div class="info">
                <p class="hoverShow-title">{{ item.hoverShow.title }}</p>
                <div
                  class="item"
                  v-for="(info, infoIndex) in item.hoverShow.content"
                  :key="infoIndex"
                >
                  <p>{{ info.title }}</p>
                  <p>{{ info.pre }}</p>
                </div>
                <a :href="item.hoverShow.route">了解更多</a>
              </div>
            </div>
          </swiper-slide>
          <div
            class="swiper-button swiper-button-prev"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button swiper-button-next"
            slot="button-next"
          ></div>
        </swiper>
      </div>
    </div>
    <div class="ty">
      <img :src="require('@/assets/images/ty1.png')" alt="" class="ty1" />
      <div class="ty-list d-flex d-flex-aic d-flex-jc-sb d-flex-fw-w">
        <div class="item">
          <img
            :src="require('@/assets/images/ty2.png')"
            alt=""
            class="item-imgs"
          />
          <div class="item-info">
            <img :src="require('@/assets/images/ty3.png')" alt="" />
            <img :src="require('@/assets/images/ty7.png')" alt="" />
            <p>全国地区秒连接</p>
            <p>全国城市千万动态IP</p>
          </div>
        </div>
        <div class="item">
          <img
            :src="require('@/assets/images/ty2.png')"
            alt=""
            class="item-imgs"
          />
          <div class="item-info">
            <img :src="require('@/assets/images/ty4.png')" alt="" />
            <img :src="require('@/assets/images/ty8.png')" alt="" />
            <p>海量IP资源</p>
            <p>动态IP,静态IP，一键掌握</p>
          </div>
        </div>
        <div class="item">
          <img
            :src="require('@/assets/images/ty2.png')"
            alt=""
            class="item-imgs"
          />
          <div class="item-info">
            <img :src="require('@/assets/images/ty5.png')" alt="" />
            <img :src="require('@/assets/images/ty9.png')" alt="" />
            <p>高匿名代理</p>
            <p>防止跟踪，身份保护</p>
          </div>
        </div>
        <div class="item">
          <img
            :src="require('@/assets/images/ty2.png')"
            alt=""
            class="item-imgs"
          />
          <div class="item-info">
            <img :src="require('@/assets/images/ty6.png')" alt="" />
            <img :src="require('@/assets/images/ty10.png')" alt="" />
            <p>高质量IP出口</p>
            <p>金融IP专线机房 稳如磐石</p>
          </div>
        </div>
      </div>
    </div>
    <div class="compare-product">
      <p class="title">产品比较</p>
      <div class="width1534">
        <tableComponent :columns="columns" :tableData="tableData" />
        <!-- <img
          :src="require('@/assets/images/compare-product.png')"
          alt=""
          class="w-100"
        /> -->
      </div>
    </div>
    <div class="use-project">
      <p class="title">使用项目</p>
      <div
        class="width1534 use-project-list d-flex d-flex-aic d-flex-jc-sb d-flex-fw-w"
      >
        <div class="item" v-for="(item, index) in useProject" :key="index">
          <img :src="item.imgUrl" alt="" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
    <div class="zx">
      <div class="zx-left d-flex d-flex-jc-c d-flex-fdc">
        <p>资讯</p>
        <p>news</p>
        <a href="">查看更多</a>
      </div>
      <div class="zx-right d-flex d-flex-jc-c">
        <swiper class="zx-swiper" :options="zxSwiperOption">
          <swiper-slide v-for="(item, index) in zxSwiperData" :key="index">
            <div class="zx-list">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
              <p>{{ item.date }}</p>
            </div>
          </swiper-slide>
          <div
            class="swiper-button swiper-button-prev"
            slot="button-prev"
          ></div>
          <div
            class="swiper-button swiper-button-next"
            slot="button-next"
          ></div>
        </swiper>
      </div>
    </div>
    <!--<div>
      <b-modal id="bv-modal-example" size="xl">
        <template #modal-title>
          <code>用户实名信息认证规则更新通知</code>
        </template>

        <p>各位尊敬的多贝云户：</p>
        <p>您好!</p>
        <p>依据《中华人民共和国网络安全法》第二十四条第一款规定：网络运营者为用户办理网络接入、域名注册服务，办理固定电话、移动电话等入网手续，或者为用户提供信息发布、即时通讯等服务，在与用户签订协议或者确认提供服务时，应当要求用户提供真实身份信息。用户不提供真实身份信息的，网络运营者不得为其提供相关服务。为全面贯彻落实《中华人民共和国网络安全法》保障网络安全，维护网络空间主权和国家安全、社会公共利益。现要求用户必须提供真实有效的身份验证：</p>
        <p>为保证身份验证的稳定真实性，本公告发布即日起用户身份验证有效期为自认证成功日起六个月，到期后必须重新认证，否则将无法进行产品续费、新购等操作。</p>

        <p>具体要求如下：</p>
        <p>1.自2024年6月1日前认证成功且仍在使用多贝云产品的用户，需于2024年10月20日前重新提交认证；2024年6月1日后认证成功的用户，身份认证有效期即为自认证成功起六个月。</p>
        <p>2.关于认证等级：</p>
        <p>（1）基础认证：单独完成个人认证<br>可购买、续费使用的产品为HTTP隧道代理、家庭住宅短效代理（身份认证信息有效期为六个月）</p>
        <p>（2）高级认证：完成基础认证、提供产品使用主体企业资质、上传企业盖章版用户安全承诺书<br>可购买、续费使用产品为HTTP隧道代理、家庭住宅短效代理、家庭住宅长效代理（高级认证内含基础认证，基础认证有效期一律为六个月，到期后仍需重新进行认证，超时未重新认证亦影响相关新购、续费功能）</p>
        <p>注：为保障多贝云用户的使用稳定与安全，各用户提供的信息以及附件文件必须真实有效，一经发现虚假无效信息，将按上级单位要求作清退处理，不予退款。</p>

        <p>广州多贝网络科技有限公司</p>
        <p>2024年09月28日</p>

        <template #modal-footer>
          <div class="w-100">
            <b-button
                variant="primary"
                size="sm"
                class="float-right"
                @click="$bvModal.hide('bv-modal-example')"
            >
              确 定
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>-->
  </div>
</template>

<script>
import banner from "@/components/banner";
import tableComponent from "@/components/tableComponent.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "index",
  components: {
    banner,
    tableComponent,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      updateDialog: true,
      screenWidth: null, //页面尺寸变化
      swiperData: [
        {
          title: "多贝云HTTP隧道代理",
          content: "基于运营商一手线路资源",
          descript: ["完全自建节点", "高效稳定纯净", "便捷易用"],
          btn: [
            {
              icon: require("@/assets/images/banner_icon1.png"),
              text: "免费咨询",
            },
            {
              icon: require("@/assets/images/banner_icon2.png"),
              text: "立刻试用",
            },
          ],
          imgUrl: require("@/assets/images/banner3.png"),
          mimgUrl: require("@/assets/images/mbanner1.jpg"),
        },
        {
          title: "多贝云家庭住宅代理",
          content: "基于运营商一手线路资源 --- 真实家庭住宅IP",
          descript: [
            "延迟毫秒级别",
            "完全自建节点",
            "便捷易用",
            "高效稳定纯净",
          ],
          btn: [
            {
              icon: require("@/assets/images/banner_icon3.png"),
              text: "短效代理",
              route: "/proxysmall",
            },
            {
              icon: require("@/assets/images/banner_icon4.png"),
              text: "长效代理",
              route: "/proxylong",
            },
          ],
          imgUrl: require("@/assets/images/banner2.png"),
          mimgUrl: require("@/assets/images/mbanner2.jpg"),
        },
        {
          title: "多贝云静态代理",
          content: "基于运营商一手线路资源",
          descript: ["完全自建节点", "高效稳定纯净", "便捷易用"],
          btn: [
            {
              icon: require("@/assets/images/banner_icon1.png"),
              text: "免费咨询",
            },
            {
              icon: require("@/assets/images/banner_icon2.png"),
              text: "立刻试用",
            },
          ],
          imgUrl: require("@/assets/images/banner1.png"),
          mimgUrl: require("@/assets/images/mbanner3.jpg"),
        },
      ],
      productSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 70,
        loop: true,
        loopFillGroupWithBlank: true,
        observeParents: true,
        observer: true,
        navigation: {
          nextEl: ".product-swiper .swiper-button-next",
          prevEl: ".product-swiper .swiper-button-prev",
        },
        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      productSwiperData: [
        {
          title: "HTTP隧道代理",
          content:
            "多贝云动态HTTP代理隧道，基于运营商一手线路资源，完全自建节点，高效稳定、纯净、便捷易用。",
          price: "500元/月",
          imgUrl: require("@/assets/images/product_01.png"),
          hoverShow: {
            title: "HTTP隧道代理",
            route: "/proxyhttp",
            content: [
              {
                id: 0,
                title: "使用方式",
                pre: "无需提取，提供固定的代理接入IP及端口。根据不同套餐 IP 可用时长不一样",
              },
              {
                id: 1,
                title: "支持的协议",
                pre: "HTTP/HTTPS 协议",
              },
              {
                id: 2,
                title: "计费方式",
                pre: "包月，无 IP 限制",
              },
              {
                id: 3,
                title: "套餐介绍",
                pre: "根据 IP 可用时长分为套餐一、套餐二、套餐三，到期自动切换 IP",
              },
            ],
          },
        },
        // 超级HTTP隧道代理产品卡片已隐藏
        {
          title: "家庭住宅代理 IP 短效套餐",
          content: "适用场景：数据采集、搜索引擎优化（SEO）广告竞价和竞品监控",
          price: "0.012元/个",
          imgUrl: require("@/assets/images/product_04.png"),
          hoverShow: {
            title: "家庭住宅短效IP代理",
            route: "/proxysmall",
            content: [
              {
                id: 0,
                title: "使用方式",
                pre: "用户使用 API 提取的方式，获取到分布式中心代理服务器的 IP 以及代理端口。一个代理端口对应一个出口 IP",
              },
              {
                id: 1,
                title: "支持的协议",
                pre: "HTTP、SOCKS5",
              },
              {
                id: 2,
                title: "计费方式",
                pre: "按 IP 提取量，提取了就开始计费。",
              },
              {
                id: 3,
                title: "套餐介绍",
                pre: "套餐按代理 IP 可用时长，分为 1 分钟、3 分钟、5 分钟、10 分钟。代理端口到期自动关闭",
              },
            ],
          },
        },
        {
          title: "家庭住宅代理 IP 长效套餐",
          content:
            "独享IP和带宽的代理模式，可灵活控制IP的存活时长，相较于共享代理模式能更有效的保",
          price: "120元/月",
          imgUrl: require("@/assets/images/product_03.png"),
          hoverShow: {
            title: "家庭住宅长效IP代理",
            route: "/proxylong",
            content: [
              {
                id: 0,
                title: "使用方式",
                pre: "用户使用 API 提取方式，获取到中心代理服务器的 IP 以及代理端口。一个代理端口对应一个出口 IP",
              },
              {
                id: 1,
                title: "支持的协议",
                pre: "HTTP、SOCKS5",
              },
              {
                id: 2,
                title: "计费方式",
                pre: "按线路数（并发数）计费，一个代理端口对应一条线路（并发数）。",
              },
              {
                id: 3,
                title: "套餐介绍",
                pre: "不限制单次提取量，但是单次提取的最大值为购买的线路数（并发数），提取间隔65 秒。代理端口使用时长要满足 15 分钟以上",
              },
            ],
          },
        },
        {
          title: "静态IP代理",
          content:
            "IP资源来源于运营商原生资源。独享IP及带宽。IP长期稳定不变，不可切换。                           ",
          price: "80元/月",
          imgUrl: require("@/assets/images/product_02.png"),
          hoverShow: {
            title: "静态IP代理",
            route: "/proxyip",
            content: [
              {
                id: 0,
                title: "使用方式",
                pre: "用户使用 API提取的方式，获取到分布式中心代理服务器的 IP 以及代理端口。一个代理端口对应",
              },
              {
                id: 1,
                title: "支持的协议",
                pre: "HTTP、SOCKS5",
              },
              {
                id: 2,
                title: "计费方式",
                pre: "按 IP 提取量，提取了就开始计费。",
              },
              {
                id: 3,
                title: "套餐介绍",
                pre: "套餐按代理 IP 可用时长，分为 1 分钟、3 分钟5 分钟、10 分钟。代理端口到期自动关团",
              },
            ],
          },
        },
      ],
      useProject: [
        {
          title: "账号注册",
          imgUrl: require("@/assets/images/user-project1.png"),
        },
        {
          title: "游戏测试",
          imgUrl: require("@/assets/images/user-project2.png"),
        },
        {
          title: "营销优化",
          imgUrl: require("@/assets/images/user-project3.png"),
        },
        {
          title: "推广宣传",
          imgUrl: require("@/assets/images/user-project4.png"),
        },
        {
          title: "数据采集",
          imgUrl: require("@/assets/images/user-project5.png"),
        },
        {
          title: "论坛发帖",
          imgUrl: require("@/assets/images/user-project6.png"),
        },
        {
          title: "投票助力",
          imgUrl: require("@/assets/images/user-project7.png"),
        },
        {
          title: "问答推广",
          imgUrl: require("@/assets/images/user-project8.png"),
        },
        {
          title: "爬虫抓取",
          imgUrl: require("@/assets/images/user-project9.png"),
        },
        {
          title: "SEO优化",
          imgUrl: require("@/assets/images/user-project10.png"),
        },
      ],
      zxSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 98,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".zx-swiper .swiper-button-next",
          prevEl: ".zx-swiper .swiper-button-prev",
        },
        breakpoints: {
          1400: {
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      },
      zxSwiperData: [
        {
          title: "多贝云取得IP-VPN证书",
          content: "我们取得国家颁发的IP-VPN证书啦！",
          date: "2017-08-24 10:28",
        },
        {
          title: "赛车游戏玩的好，不代表你能在现实世界里一骑绝尘",
          content: "是从什么时候开始意识到，游戏和现实是不一样的呢？",
          date: "2017-08-24 10:28",
        },
        {
          title: "用户中心机房动态拨号网络解决方案",
          content:
            "本产品方案针对对产品的容错性，安全性要求高的高端企业用户提供...",
          date: "2017-08-24 10:28",
        },
      ],
      columns: [
        { key: "productname", name: "产品名称" },
        { key: "httpname", name: "HTTP隧道代理" },
        { key: "jingtainame", name: "静态IP代理" },
        { key: "familysmall", name: "家庭住宅IP短效套餐" },
        { key: "familylong", name: "家庭住宅IP长效套餐" },
      ],
      tableData: [
        {
          productname: "计费模式",
          httpname: "按时长和请求数包月",
          jingtainame: "按线路数包月",
          familysmall: "按IP量",
          familylong: "按线路数包月",
        },
        {
          productname: "IP池",
          httpname: "运营商传统代理资源池",
          jingtainame: "运营商一手资源池固定住宅IP、企业专线IP",
          familysmall: "纯净家庭住宅IP",
          familylong: "纯净家庭住宅IP",
        },
        {
          productname: "是否独享",
          httpname: "否",
          jingtainame: "是",
          familysmall: "否",
          familylong: "是",
        },
        {
          productname: "是否去重",
          httpname: "否",
          jingtainame: "-",
          familysmall: "自主去重",
          familylong: "否",
        },
        {
          productname: "是否支持指定地区",
          httpname: "否",
          jingtainame: "是",
          familysmall: "是",
          familylong: "是",
        },
        {
          productname: "是否中心化产品",
          httpname: "是",
          jingtainame: "否",
          familysmall: "是",
          familylong: "是",
        },
        {
          productname: "IP存活时长",
          httpname: "1-10分钟固定时长,每次请求自动切换",
          jingtainame: "长期有效",
          familysmall: "1分钟、3分钟、5分钟、10分钟",
          familylong: "24小时以上",
        },
        {
          productname: "带宽峰值",
          httpname: "基础套餐1Mbps，最高5Mbps",
          jingtainame: "5Mbps",
          familysmall: "2Mbps",
          familylong: "2Mbps",
        },
        {
          productname: "请求数限制",
          httpname: "根据购买的请求数",
          jingtainame: "不限制",
          familysmall: "不限制",
          familylong: "不限制",
        },
        {
          productname: "IP切换方式",
          httpname: "自主切换或自动切换",
          jingtainame: "不可切换",
          familysmall: "到期自动释放，重新提取",
          familylong: "主动释放，重新提取",
        },
        {
          productname: "单次提取数",
          httpname: "-",
          jingtainame: "-",
          familysmall: "200",
          familylong: "购买的线路数",
        },
        {
          productname: "IP白名单数量",
          httpname: "-",
          jingtainame: "-",
          familysmall: "200",
          familylong: "5",
        },
        {
          productname: "可用率",
          httpname: "95%",
          jingtainame: "100%",
          familysmall: "95%",
          familylong: "95%",
        },
        {
          productname: "协议支持",
          httpname: "http(s)",
          jingtainame: "http(s)、socks5、ss",
          familysmall: "http(s)、socks5",
          familylong: "http(s)、socks5",
        },
        {
          productname: "是否api提取",
          httpname: "否",
          jingtainame: "否",
          familysmall: "是",
          familylong: "是",
        },
        {
          productname: "验证方式",
          httpname: "账密",
          jingtainame: "账密",
          familysmall: "账密/IP白名单",
          familylong: "账密/IP白名单",
        },
        {
          productname: "终端要求",
          httpname: "不限制",
          jingtainame: "不限制",
          familysmall: "不限制",
          familylong: "不限制",
        },
        {
          productname: "是否支持定制化",
          httpname: "是",
          jingtainame: "是",
          familysmall: "是",
          familylong: "是",
        },
        {
          productname: "是否高匿",
          httpname: "是",
          jingtainame: "是",
          familysmall: "是",
          familylong: "是",
        },
        {
          productname: "IP资源池大小",
          httpname: "100w",
          jingtainame: "地区多样",
          familysmall: "500w",
          familylong: "50w",
        },
      ],
    };
  },
  // mounted() {
  //   this.screenWidth = document.body.clientWidth;
  //   window.onresize = () => {
  //     return (() => {
  //       this.screenWidth = document.body.clientWidth;
  //     })();
  //   };
  // },
  // watch: {
  //   screenWidth: {
  //     handler: function (val, oldVal) {
  //       if (val < 768) {
  //         this.swiperData.map((item, index) => {
  //           return {
  //             ...item,
  //             imgUrl: require(`@/assets/images/mbanner${index + 1}.jpg`),
  //           };
  //         });
  //         console.log(this.swiperData);
  //       }
  //       //       if (val && val < 1200) {
  //       //         this.changeProductSwiperOption('under')
  //       //         console.log('屏幕宽度小于1200px')
  //       //       } else {
  //       //         this.changeProductSwiperOption('upwards')
  //       //         console.log('屏幕宽度大于1200px')
  //       //       }
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    changeProductSwiperOption(attr) {
      if (attr == "under") {
        this.productSwiperOption.slidesPerView = 2;
        this.productSwiperOption.spaceBetween = 30;
      } else {
        this.productSwiperOption.slidesPerView = 3;
        this.productSwiperOption.spaceBetween = 70;
      }
    },
  },
  mounted() {
    this.$bvModal.show('bv-modal-example')
  }
};
</script>

<style lang="less">
.index {
  .our-product {
    padding-top: 64px;
    background: #fafbfd;
    .title {
      font-size: 30px;
      color: #111;
      text-align: center;
      margin-bottom: 50px;
    }
    .swiper-slide {
      border-radius: 10px;
      .product-list {
        background: #fff;
        padding: 68px 0 44px;
        text-align: center;
        border-radius: 10px;
        p {
          color: #111;
          &:nth-of-type(1) {
            font-size: 24px;
          }
          &:nth-of-type(2) {
            width: 80%;
            margin: 24px auto 0;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          &:nth-of-type(3) {
            margin-top: 30px;
            font-size: 30px;
            color: #2e56c7;
          }
        }
        img {
          margin-top: 30px;
        }
      }
      .product-list-show {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #2e56c7;
        border-radius: 10px;
        .info {
          width: 88%;
          margin: 40px auto;
          .item {
            margin-bottom: 30px;
            p {
              &:nth-of-type(1) {
                font-size: 18px;
                color: #fff;
                margin-bottom: 6px;
              }
              &:nth-of-type(2) {
                font-size: 14px;
                color: #c5d3fa;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
        p {
          font-size: 16px;
          color: #fff;
          &.hoverShow-title {
            text-align: center;
            font-size: 24px;
          }
        }
        a {
          display: block;
          margin: 0 auto;
          text-align: center;
          line-height: 40px;
          width: 68%;
          color: #333;
          background-color: #fff;
          border-radius: 6px;
        }
      }
      &:hover {
        box-shadow: 0 2px 24px 0px #ccd6f0;
        .product-list-show {
          display: block;
        }
      }
    }
    .swiper-container {
      padding: 0 70px;
    }
    .swiper-button {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      &.swiper-button-prev {
        left: 0px;
        background: url("../assets/images/prev.png");
        background-size: 100% 100%;
        &:after {
          content: "";
        }
      }
      &.swiper-button-next {
        right: 0px;
        background: url("../assets/images/next.png");
        background-size: 100% 100%;
        &:after {
          content: "";
        }
      }
    }
  }
  .ty {
    padding-top: 166px;
    background: #fafbfd;
    position: relative;
    .ty1 {
      width: 48%;
    }
    .ty-list {
      position: absolute;
      width: 48%;
      left: 42.5%;
      top: 50%;
      transform: translate(0, -40%);
      .item {
        margin-top: 36px;
        width: 48%;
        height: 252px;
        background: #fafbfd;
        border-radius: 16px;
        box-shadow: 0 2px 10px 2px #becbee;
        position: relative;
        overflow: hidden;
        .item-imgs {
          display: none;
        }
        .item-info {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          border-radius: 16px;
          img {
            &:nth-of-type(2) {
              display: none;
            }
          }
          p {
            &:nth-of-type(1) {
              font-size: 24px;
              color: #2e56c7;
              margin-top: 20px;
              position: relative;
              &::before {
                content: "";
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
                bottom: -10px;
                width: 90px;
                height: 1px;
                background: #2e56c7;
              }
            }
            &:nth-of-type(2) {
              font-size: 18px;
              color: #111;
            }
          }
        }
        &:hover {
          background: transparent;
          box-shadow: none;
          .item-imgs {
            display: block;
          }
          .item-info {
            background: rgba(0, 0, 0, 0.4);
            img {
              &:nth-of-type(1) {
                display: none;
              }
              &:nth-of-type(2) {
                display: block;
              }
            }
            p {
              color: #fff;
              &:nth-of-type(1) {
                &::before {
                  background: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
  .compare-product {
    padding: 144px 0 40px;
    background: #fafbfd;
    .title {
      font-size: 30px;
      color: #111;
      text-align: center;
      margin-bottom: 50px;
    }
  }
  .use-project {
    padding: 70px 0 120px;
    .title {
      font-size: 30px;
      color: #111;
      text-align: center;
    }
    .use-project-list {
      .item {
        margin-top: 50px;
        width: 20%;
        text-align: center;
        p {
          margin-top: 10px;
          font-size: 20px;
          color: #111;
        }
        &:hover p {
          color: #2e56c7;
        }
      }
    }
  }
  .zx {
    background: #ebeff6;
    height: 380px;
    position: relative;
    .zx-left {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 44%;
      background: #fafbfd;
      p {
        padding-left: 30%;
        &:nth-of-type(1) {
          font-size: 36px;
          color: #111;
        }
        &:nth-of-type(2) {
          margin-top: -20px;
          font-family: "Impact";
          font-size: 80px;
          color: #e8ecf0;
          text-transform: uppercase;
        }
      }
      a {
        padding-left: 30%;
        font-size: 18px;
        color: #004cba;
        text-decoration: underline;
        &:hover {
          font-weight: bold;
        }
      }
    }
    .zx-right {
      position: absolute;
      right: 6%;
      top: 0;
      height: 100%;
      width: 60%;
      .zx-swiper {
        padding: 60px 0;
        .zx-list {
          padding: 26px;
          background: #fff;
          border: 1px solid #d7e0fa;
          border-radius: 16px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            &:nth-of-type(1) {
              color: #111;
              height: 42px;
            }
            &:nth-of-type(2) {
              color: #4d5662;
              height: 42px;
            }
            &:nth-of-type(1),
            &:nth-of-type(2) {
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden; //溢出内容隐藏
              text-overflow: ellipsis; //文本溢出部分用省略号表示
              display: -webkit-box; //特别显示模式
              -webkit-line-clamp: 2; //行数
              line-clamp: 2;
              -webkit-box-orient: vertical; //盒子中内容竖直排列
            }
            &:nth-of-type(3) {
              color: #8493a8;
            }
          }
        }
        .swiper-button {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          &.swiper-button-prev {
            left: 11%;
            top: 90%;
            background: url("../assets/images/zx-prev.png");
            background-size: 100% 100%;
            &:after {
              content: "";
            }
          }
          &.swiper-button-next {
            left: 19%;
            top: 90%;
            background: url("../assets/images/zx-next.png");
            background-size: 100% 100%;
            &:after {
              content: "";
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1500px) {
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    left: 10%;
  }
}
@media (max-width: 1200px) {
  .index .our-product {
    padding-top: 4%;
  }
  .index .our-product .title,
  .index .compare-product .title,
  .index .use-project .title,
  .index .zx .zx-left p:nth-of-type(1) {
    font-size: 24px;
    margin-bottom: 4%;
  }
  .index .our-product .product-list,
  .index .use-project {
    padding: 4% 0;
  }
  .index .our-product .product-list p:nth-of-type(1) {
    font-size: 18px;
  }
  .index .our-product .product-list p:nth-of-type(2) {
    font-size: 14px;
    margin: 2% auto 0;
  }
  .index .our-product .product-list img {
    margin-top: 3%;
  }
  .index .our-product .product-list p:nth-of-type(3) {
    font-size: 24px;
    margin-top: 3%;
  }
  .index .our-product .swiper-button {
    width: 40px;
    height: 40px;
  }
  .index .ty {
    padding-top: 6%;
  }
  .index .ty .ty-list {
    width: 55%;
  }
  .index .ty .ty-list .item {
    height: 210px;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(1) {
    font-size: 20px;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(2),
  .index .use-project .use-project-list .item p {
    font-size: 16px;
  }
  .index .compare-product {
    padding: 8% 0;
  }
  .index .use-project .use-project-list .item {
    margin-top: 2%;
  }
  .index .zx .zx-left p:nth-of-type(2) {
    font-size: 50px;
  }
  .index .zx .zx-left a {
    font-size: 14px;
  }
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    left: 9%;
  }
}
@media (max-width: 1024px) {
  .index .ty .ty1 {
    width: 100%;
    border-radius: 0;
  }
  .index .ty .ty-list {
    position: static;
    width: 96%;
    transform: translate(0, 0);
    margin-left: 2%;
  }
  .index .ty .ty-list .item {
    margin-top: 2%;
    width: 49%;
    height: auto;
  }
  .index .ty .ty-list .item .item-imgs {
    display: block;
    width: 100%;
  }
  .index .ty .ty-list .item .item-info {
    background: rgba(0, 0, 0, 0.4);
  }
  .index .ty .ty-list .item .item-info img:nth-of-type(1) {
    display: none;
  }
  .index .ty .ty-list .item .item-info img:nth-of-type(2) {
    display: inline-block;
  }
  .index .ty .ty-list .item .item-info p {
    color: #fff !important;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(1)::before {
    background: #fff;
  }
  .index .zx .zx-left {
    padding: 1% 0;
    position: static;
    width: 100%;
    height: auto;
    text-align: center;
  }
  .index .zx .zx-left p,
  .index .zx .zx-left a {
    padding-left: 0;
  }
  .index .zx .zx-right {
    position: static;
    width: 96%;
    margin: 0 auto;
  }
  .index .zx .zx-right .zx-swiper {
    padding: 2% 0;
  }
  .index .zx .zx-left p:nth-of-type(1) {
    margin-bottom: 0;
  }
  .index .zx .zx-left p:nth-of-type(2) {
    display: none;
  }
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-next {
    top: 70%;
    left: 52%;
  }
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    top: 70%;
    left: 47%;
  }
}
@media (max-width: 768px) {
  .index .our-product .swiper-slide .product-list p:nth-of-type(3) {
    font-size: 24px;
  }
  .index .our-product .title,
  .index .compare-product .title,
  .index .use-project .title,
  .index .our-product .swiper-slide .product-list p:nth-of-type(1),
  .index .our-product .swiper-slide .product-list-show p.hoverShow-title {
    font-size: 20px;
  }
  .index .our-product .swiper-slide .product-list p:nth-of-type(2),
  .index .ty .ty-list .item .item-info p:nth-of-type(1) {
    font-size: 16px;
  }
  .index .our-product .product-list p:nth-of-type(2),
  .index .our-product .swiper-slide .product-list-show a {
    font-size: 12px;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(2),
  .index .use-project .use-project-list .item p,
  .index .our-product .swiper-slide .product-list-show p {
    font-size: 14px;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(1)::before {
    width: 36%;
  }
  .index .use-project .use-project-list .item {
    width: 33.33%;
  }
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    left: 43%;
  }
  .index .our-product .swiper-slide .product-list-show .info .item {
    margin-bottom: 20px;
  }
  .index .our-product .swiper-slide .product-list {
    padding: 4% 0;
  }
  .banner .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 40px;
  }
  .index .our-product .swiper-button {
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 640px) {
  .index .our-product .title,
  .index .compare-product .title,
  .index .use-project .title,
  .index .our-product .swiper-slide .product-list p:nth-of-type(1),
  .index .our-product .swiper-slide .product-list-show p.hoverShow-title {
    font-size: 18px;
  }
  .index .our-product .swiper-slide .product-list p:nth-of-type(2),
  .index .ty .ty-list .item .item-info p:nth-of-type(1),
  .index
    .our-product
    .swiper-slide
    .product-list-show
    .info
    .item
    p:nth-of-type(1) {
    font-size: 14px;
  }
  .index .ty .ty-list .item .item-info p:nth-of-type(2),
  .index .use-project .use-project-list .item p,
  .index .our-product .swiper-slide .product-list-show p,
  .index
    .our-product
    .swiper-slide
    .product-list-show
    .info
    .item
    p:nth-of-type(2) {
    font-size: 12px;
  }
  .index .our-product .swiper-slide .product-list p:nth-of-type(3) {
    font-size: 20px;
  }
  .index .ty .ty-list .item {
    width: 100%;
  }
  .index .use-project .use-project-list .item {
    width: 50%;
  }
  .index .our-product .swiper-slide .product-list-show .info .item {
    margin-bottom: 10px;
  }
}
@media (max-width: 575px) {
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    left: 40%;
  }
  .index .our-product .swiper-slide .product-list-show .info {
    margin: 4% auto;
  }
  .index .our-product .swiper-slide .product-list-show a {
    line-height: 30px;
    width: 50%;
  }
}
@media (max-width: 475px) {
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-prev {
    left: 38%;
  }
  .index .zx .zx-right .zx-swiper .swiper-button.swiper-button-next {
    left: 54%;
  }
  .index
    .our-product
    .swiper-slide
    .product-list-show
    .info
    .item
    p:nth-of-type(2) {
    -webkit-line-clamp: 1;
  }
}
@media (max-width: 375px) {
  .index .our-product .swiper-slide .product-list-show p.hoverShow-title {
    margin-bottom: 0;
  }
}
</style>
